import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { PopoverController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SelectOption } from 'src/app/components/forms/select/select.component';
import { Exercise } from 'src/app/models/Exercise';
import { Pagination } from 'src/app/models/Pagination';
import { User } from 'src/app/models/User';
import { ExerciseProvider } from 'src/app/providers/ExerciseProvider';
import { YoutubeProvider } from 'src/app/providers/YoutubeProvider';

@Component({
    selector: 'app-exercise-select',
    templateUrl: './exercise-select.page.html',
    styleUrls: ['./exercise-select.page.scss'],
    standalone: false
})

/**
  * Popover de seleccion de ejercicio
  * muestra, detalla y seleccionar ejercicio a añadir al entrenamiento
  */
export class ExerciseSelectPage implements OnInit {


  exercises: Exercise[] = [];
  user: User = new User();
  typeGym:any = 1;
  pagInfo: Pagination = new Pagination();
  exerciseTypes: SelectOption[] = [];
  formExercise = new FormGroup<any>({
    t_exercise: new FormControl(),
    search: new FormControl(''),
  })
  plan:any;
  constructor(
    private exerciseProvider: ExerciseProvider,
    private spinner: NgxSpinnerService,
    private storage: Storage,
    private popoverController: PopoverController
  ) { 
    this.formExercise.controls.search.valueChanges
    .pipe(
      debounceTime(700),
      distinctUntilChanged(),
    ).subscribe(res => {
      this.getListAll(1);
    });

  }

  async ngOnInit() {
    this.plan=await this.storage.get('gymSubscription');
    this.typeGym = '1';
    this.user = await this.storage.get('user');
    this.getExercisesTypes();
  }

  /**
    * @author Sergio Castro
    * @description  Obtiene el listado de los tipos de ejercicios
    * @date 26 Enero 2021
    * @return
   */
  async getExercisesTypes() {
    const exercises = await this.exerciseProvider.getExerciseType();
    this.exerciseTypes.push({
      value: '0',
      label: 'Todos',
      selected: true
    });
    exercises.map(type => {
      this.exerciseTypes.push({
        value: type.id,
        label: type.nombre
      });
    });
    this.getListAll(this.pagInfo.currentPage);
  }

  /**
    * @author Sergio Castro
    * @description Obtiene la lista de ejercicios paginados
    * @date 26 Enero 2021
    * @param page
    * @return
   */
  async getListAll(page) {
    //alert(this.formExercise.value.t_exercise)
    this.exercises = [];
    this.spinner.show();
    const info = {
      page: page,
      search: this.formExercise.value.search,
      gymId: this.typeGym == 1 ? 1: this.user.id_gimnasio,
      exerciseType: this.formExercise.value.t_exercise
    };
    let result = null;
    result = await this.exerciseProvider.getExercises(info);
    this.spinner.hide();
    this.pagInfo.currentPage = result.meta.current_page;
    this.pagInfo.totalPages = result.meta.last_page;
    if (result.exercises.length > 0) {
      result.exercises.forEach(exercise => {
        this.exercises.push(exercise.props);
      });
    }
  }

  /**
    * @author Sergio Castro
    * @description Retorna el ejercicio seleccionado
    * @date 26 Enero 2021
    * @param exercise
    * @return
   */
  selectExercise(exercise){
    this.popoverController.dismiss(exercise);
  }

  /**
    * @author Sergio Castro
    * @description Regresa a la página anterior
    * @date 26 Enero 2021
    * @param 
    * @return
   */
  regresar(){
    this.popoverController.dismiss();
  }
}
